<template>
  <li class="user-actions__item user-actions__item--wishlist" @mouseleave="hidePopup">
    <a
      v-on="isTouch ? {click: togglePopup} : {mouseenter: showPopup}"
      class="user-actions__link wish-list-btn"
      :class="{'wish-list-btn--hovered': isPopupVisible}"
      :href="urlLanguagePrefix + '/cabinet/wishlist/'"
      @click="clickAction"
    >
      <svg class="wish-list-btn__svg"
           width="25"
           height="21"
           stroke="#47474B"
           stroke-width="2">
        <use :xlink:href="spritePath + '#wishlist'"></use>
      </svg>
      <span v-if="wishlistQuantity" class="user-actions__cart-counter">{{ wishlistQuantity }}</span>
    </a>
    <HeaderPopup :is-popup-visible="isPopupVisible && !wishlistQuantity" :is-empty-popup="!wishlistQuantity" type="wishlist" />
    <div class="wish-list-btn__overlay wish-list-overlay"></div>
  </li>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { spritePath } from '@/mixins/spritePath'
import { isTouch } from '@/mixins/isTouchDevice'
import HeaderPopup from '@/components/helpers/HeaderPopup'

export default {
  name: 'HeaderWishlist',
  components: {
    HeaderPopup
  },
  mixins: [spritePath, isTouch],
  data () {
    return {
      isPopupVisible: false,
      isOverlayOpen: false
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix']),
    ...mapGetters('wishlist', ['wishlistQuantity']),
    ...mapState({
      userDataFromServer: state => state.user
    })
  },
  methods: {
    ...mapActions(['FETCH_WISHLIST']),
    showModal () {
      this.$modal.show('auth-modal', { url: '/cabinet/wishlist/' })
    },
    clickAction (e) {
      if (this.userDataFromServer && this.userDataFromServer.auth) {
        return null
      } else {
        e.preventDefault()
        this.showModal()
      }
    },
    showPopup () {
      this.isPopupVisible = true
      this.isOverlayOpen = true
    },
    hidePopup () {
      this.isPopupVisible = false
      this.isOverlayOpen = false
    },
    togglePopup () {
      this.isPopupVisible = !this.isModalVisible
      this.isOverlayOpen = !this.isOverlayOpen
    }
  },
  mounted () {
    window.addEventListener('removeFromWishlist', () => this.FETCH_WISHLIST())
  }
}
</script>
